var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72074 13.6816L1.50312 9.45933C1.29579 9.25083 1.14504 8.99291 1.06512 8.70994C0.985193 8.42698 0.978732 8.1283 1.04634 7.84214C1.11396 7.55598 1.25341 7.29178 1.45153 7.07451C1.64965 6.85724 1.89989 6.69406 2.17862 6.6004L18.7244 1.08565C19.029 0.983883 19.3559 0.969 19.6684 1.04267C19.981 1.11633 20.2668 1.27563 20.4939 1.5027C20.7209 1.72976 20.8802 2.0156 20.9539 2.32815C21.0276 2.6407 21.0127 2.9676 20.9109 3.27216L15.4008 19.818C15.3075 20.0976 15.1443 20.3487 14.9266 20.5475C14.709 20.7463 14.4442 20.8862 14.1573 20.9538C13.8704 21.0215 13.571 21.0147 13.2874 20.9342C13.0039 20.8536 12.7457 20.7019 12.5372 20.4935L9.17977 17.1406L5.57764 19.0132L5.72074 13.6816ZM5.72074 13.6816L20.417 1.43032",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLight);
export default __webpack_public_path__ + "static/media/send-light.0ec80f0fb55ae8fd1b268c5930a7f5d5.svg";
export { ForwardRef as ReactComponent };